@if (drawingEnabled) {
<app-drawing-canvas (drawn)="handleDrawn($event)"></app-drawing-canvas>
}
